import { render, staticRenderFns } from "./reportDetail.vue?vue&type=template&id=204da36a&"
import script from "./reportDetail.vue?vue&type=script&lang=ts&"
export * from "./reportDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports